import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(
    private _snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => this._snackBar.dismiss());
  }

  showSnackBar(
    message: string,
    action: string = 'OK',
    duration: number = 2000
  ) {
    this._snackBar.open(message, action, {
      duration: duration,
      verticalPosition: 'top',
      horizontalPosition: 'right',
      //panelClass: ['asset-snackbar']
    });
  }

  showSnackBarWarning(message: string, duration: number) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: duration,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['asset-snackbar-warning'],
      data: {
        message: message,
      },
    });
  }

  showSnackBarError(message: string, duration: number) {
    this._snackBar.open(message, null, {
      duration: duration,
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: ['asset-snackbar-error'],
    });
  }

  showSnackBarSuccess(message: string, duration: number) {
    this._snackBar.open(message, null, {
      duration: duration,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['asset-snackbar-success'],
    });
  }

  showSnackBarHtmlContent(
    htmlContent: string,
    action: string = 'OK',
    duration: number = 2000
  ) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: duration,
      verticalPosition: 'top',
      horizontalPosition: 'right',
      data: {
        message: htmlContent,
        action: action,
      },
    });
  }
}
